import * as Sentry from '@sentry/vue';

const SENSITIVE_KEY_PATTERN = /authorization|cookie|token|session|password|secret|medical|patient|diagnos|prescription/i;

const getResponseStatus = (error) => error?.response?.status;

const getErrorId = (error) => error?.response?.data?.errorMessage?.errorId
  || error?.response?.data?.message?.errorId;

export const shouldCaptureException = (error) => {
  const status = getResponseStatus(error);

  return !getErrorId(error) && !(status >= 400 && status < 500);
};

const removeSensitiveValues = (value) => {
  if (!value || typeof value !== 'object') return value;

  return Object.keys(value).reduce((sanitized, key) => {
    if (!SENSITIVE_KEY_PATTERN.test(key)) sanitized[key] = value[key];
    return sanitized;
  }, {});
};

const removeQueryString = (url) => (typeof url === 'string' ? url.split('?')[0] : url);

export const scrubEvent = (event) => {
  const sanitizedEvent = { ...event };
  sanitizedEvent.extra = undefined;

  if (sanitizedEvent.request) {
    sanitizedEvent.request = {
      ...sanitizedEvent.request,
      data: undefined,
      url: removeQueryString(sanitizedEvent.request.url),
      headers: removeSensitiveValues(sanitizedEvent.request.headers),
    };
  }

  sanitizedEvent.breadcrumbs = (sanitizedEvent.breadcrumbs || []).map((breadcrumb) => ({
    ...breadcrumb,
    data: {
      ...removeSensitiveValues(breadcrumb.data),
      url: removeQueryString(breadcrumb.data?.url),
    },
  }));

  return sanitizedEvent;
};

export const initializeSentry = ({ Vue, dsn, environment }) => {
  if (!dsn) return false;

  Sentry.init({
    dsn,
    environment,
    sendDefaultPii: false,
    integrations: [
      Sentry.vueIntegration({
        Vue,
        attachProps: false,
      }),
    ],
    beforeSend: scrubEvent,
  });

  return true;
};

export const setSentryUser = (account) => {
  Sentry.setUser(account?.id ? { id: String(account.id) } : null);
};

export const captureUnexpectedException = (error, requestId) => {
  if (!shouldCaptureException(error)) return;

  Sentry.captureException(error, {
    tags: requestId ? { request_id: requestId } : undefined,
  });
};
